import React from 'react';

const RetryIcon:React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="none" viewBox="0 0 23 23">
      <path fill="#122442" d="M6.394 14.168c.207 0 .437-.069.621-.23l3.956-3.519-1.219-1.38-2.622 2.3c.07-2.944 2.37-5.451 5.313-5.75 3.266-.345 6.187 2.024 6.51 5.29.344 3.266-2.025 6.187-5.29 6.509-1.979.207-3.934-.598-5.199-2.139l-1.426 1.173c1.495 1.817 3.68 2.829 6.003 2.829.276 0 .53-.023.805-.046 4.278-.414 7.383-4.255 6.946-8.51-.437-4.255-4.278-7.383-8.533-6.923-3.657.391-6.532 3.335-6.923 6.9L3.542 8.671 2.162 9.89l3.52 3.956c.206.207.46.322.712.322z"/>
    </svg>
  )
}

export default RetryIcon;